<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <movimiento-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import MovimientoShowData from "./MovimientoShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "MovimientoShow",
        components: {CrudShow, MovimientoShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, default: null}
        },
        data() {
            return {
                title: 'movimiento.showing',
            }
        },
    }
</script>

